import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Tomos } from './components/Tomos';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen bg-brand-dark font-body selection:bg-brand-accent selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProofBar data-id="element-2" />
      <Tomos data-id="element-3" />
      <Bonuses data-id="element-4" />
      <Testimonials data-id="element-5" />
      <UrgencyBanner data-id="element-6" />
      <Pricing data-id="element-7" />
      <Guarantee data-id="element-8" />
      <FAQ data-id="element-9" />
      <Footer data-id="element-10" />
      <PurchasePopup data-id="element-11" />
    </div>;
}